import Vue from "vue";
import Router from "vue-router";

import AdminBroker from "./views/AdminBroker.vue";
import AdminTPA from "./views/AdminTPA.vue";
import AdminWholesaler from "./views/AdminWholesaler.vue";
import ClientManage from "./views/ClientManage.vue";
import BadUrl from "./views/404.vue";
import Dashboard from "./views/Dashboard.vue";
import Proposal from "./views/Proposal.vue";
import Login from "./components/logincomps/Login.vue";
import MgmtCompany from "./views/MgmtCompany.vue";
import MgmtPricing from "./views/MgmtPricing.vue";
import MgmtTemplates from "./views/MgmtTemplates.vue";
import ForgotPass from "./components/logincomps/ForgotPass.vue";
import ResetForgotPass from "./components/logincomps/ResetForgotPass.vue";
import Status from "./views/Status.vue";

import store from "./store";


Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: "*",
            name: "404",
            component: BadUrl,
            meta:{
                title: "404",
            }
        },
        {
            path: "/status",
            name: "status",
            component: Status,
            meta:{
                title: "Status",
            },
            props: true,
            beforeEnter(to, from, next){
                to.params.front = true;
                to.params.database = "N/A";
                store.dispatch('statusCheckLogin').then(value => {
                    to.params.middle = value;
                    store.dispatch('docxAPIStatus').then(obj => {
                        to.params.docxAPI = obj.docx;
                        if(obj.middle){
                            to.params.middle = obj.middle;
                        }
                        next();
                    });
                });
            }
        },
        {
            path: "/",
            name: "login",
            component: Login,
            meta: {
                title: "Login",
            }
        },
        {
            path: "/reset",
            name: "rest",
            component: ForgotPass,
            meta: {
                title: "Reset",
            }
        },
        {
            path: "/confirm",
            name: "confirm",
            component: ResetForgotPass,
            meta: {
                title: "Confirm Reset",
            }
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
            meta:{
                title: "Dashboard",
            },
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next(
                        {
                            name: 'login', 
                            query: { redirectFrom: to.fullPath}
                            
                        }
                        );
                }
            }
        },
        {
            path: "/clientmanagement",
            name: "clientmanagement",
            component: ClientManage,
            meta:{
                title: "Client Management",
            },
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next(
                        {
                            name: 'login', 
                            query: { redirectFrom: to.fullPath}
                            
                        }
                        );
                }
            }
        },
        {
            path: "/proposal",
            name: "proposal",
            component: Proposal,
            meta:{
                title: "Proposal - List",
            },
            props: true,
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next({
                        name: 'login',
                        query: { redirectFrom: to.fullPath}                            
                        });
                }
            }
        },
        {
            path: "/mgmt/company",
            name: "mgmtcompany",
            component: MgmtCompany,
            meta:{
                title: "Manage Company",
            },
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next(
                        {
                            name: 'login', 
                            query: { redirectFrom: to.fullPath}
                            
                        }
                        );
                }
            }
        },
        {
            path: "/mgmt/templates",
            name: "mgmttemplates",
            component: MgmtTemplates,
            meta:{
                title: "Manage Templates",
            },
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next(
                        {
                            name: 'login', 
                            query: { redirectFrom: to.fullPath}
                            
                        }
                        );
                }
            }
        },
        {
            path: "/mgmt/pricing",
            name: "mgmtpricing",
            component: MgmtPricing,
            meta:{
                title: "Manage Pricing",
            },
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAuth');
                if(permission) {
                    next();
                } else {
                    next(
                        {
                            name: 'login', 
                            query: { redirectFrom: to.fullPath}
                            
                        }
                        );
                }
            }
        },
        {
            path: "/admin/tpa",
            name: "adminTpa",
            component: AdminTPA,
            meta:{
                title: "Admin TPA Accounts",
            },
            props: true,
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAdmin');
                if (permission) {
                    next();
                } else {
                    next({
                        name: 'login',
                        query: { redirectFrom: to.fullPath}                            
                        });
                }
            }
        },
        {
            path: "/admin/broker",
            name: "adminBroker",
            component: AdminBroker,
            meta:{
                title: "Admin Broker Dealer",
            },
            props: true,
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAdmin');
                if (permission) {
                    next();
                } else {
                    next({
                        name: 'login',
                        query: { redirectFrom: to.fullPath}                            
                        });
                }
            }
        },
        {
            path: "/admin/wholesaler",
            name: "adminWholesaler",
            component: AdminWholesaler,
            meta:{
                title: "Admin Wholesaler",
            },
            props: true,
            async beforeEnter (to, from, next) {
                let permission = await store.dispatch('checkAdmin');
                if (permission) {
                    next();
                } else {
                    next({
                        name: 'login',
                        query: { redirectFrom: to.fullPath}                            
                        });
                }
            }
        },
    ]
});
